import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {fetchDataNew, fetchListNew} from "../../hook/axios.hook";

const initialState = {
  routines: [],
  routine: null,

  routineExecutions: [],
  operationExecutions: [],

  loading: false,
  error: false,
};

export const fetchAllRoutines = createAsyncThunk(
  "system/fetchAllRoutines",
  async (params, {signal, rejectWithValue}) => {
    return fetchListNew("/admin/routine-operations/routines", "get", {params, signal, rejectWithValue});
  },
);
export const fetchRoutine = createAsyncThunk("system/fetchRoutine", async (routineId, {signal, rejectWithValue}) => {
  return fetchDataNew(`/admin/routine-operations/routines/${routineId}`, "get", {signal, rejectWithValue});
});

export const fetchRoutineExecutions = createAsyncThunk(
  "system/fetchRoutineExecutions",
  async (routineId, {signal, rejectWithValue}) => {
    return fetchListNew(`/admin/routine-operations/routines/${routineId}/executions`, "get", {signal, rejectWithValue});
  },
);
export const fetchOperationExecutions = createAsyncThunk(
  "system/fetchOperationExecutions",
  async (routineExecutionId, {signal, rejectWithValue}) => {
    return fetchListNew(`/admin/routine-operations/executions/${routineExecutionId}`, "get", {
      signal,
      rejectWithValue,
    });
  },
);

export const SYSTEM_STORE_NAME = "system";

const systemSlice = createSlice({
  name: SYSTEM_STORE_NAME,
  initialState,
  reducers: {
    clearCurrentRoutine: state => {
      state.routine = null;
    },
    clearRoutineExecutions: state => {
      state.routineExecutions = [];
    },
    clearOperationExecutions: state => {
      state.operationExecutions = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAllRoutines.fulfilled, (state, {payload}) => {
        state.routines = payload.data;
      })
      .addCase(fetchRoutine.fulfilled, (state, {payload}) => {
        state.routine = payload;
      })

      .addCase(fetchRoutineExecutions.fulfilled, (state, {payload}) => {
        state.routineExecutions = payload.data;
      })
      .addCase(fetchOperationExecutions.fulfilled, (state, {payload}) => {
        state.operationExecutions = payload.data;
      })

      //fulfilled matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/fulfilled"),
        state => handleFulfilled(state),
      )
      //pending matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/pending"),
        state => handlePending(state),
      )
      //rejected matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/rejected"),
        (state, {error}) => handleRejected(state, error),
      )
      //default
      .addDefaultCase(() => {});
  },
});

const {actions, reducer} = systemSlice;
export default reducer;

export const {clearCurrentRoutine, clearRoutineExecutions, clearOperationExecutions} = actions;

export const selectAllRoutings = state => state.system.routines;
export const selectCurrentRoutine = state => state.system.routine;
export const selectCurrentRoutineExecutions = state => state.system.routineExecutions;
export const selectCurrentOperationExecutions = state => state.system.operationExecutions;
export const selectSystemLoading = state => state.system.loading;

function handleFulfilled(state) {
  state.loading = false;
  state.error = false;
}

function handlePending(state) {
  state.loading = true;
  state.error = false;
}

function handleRejected(state, error) {
  state.loading = false;
  state.error = error;
}
